/**
 * Is this a mobile device, task: native SMS handoff (2026-09-08).
 *
 * When this was written, no Capacitor project existed in this repo
 * (CLAUDE.md section 15) and this was a plain web/PWA context, so the only
 * signal available was the browser's own user agent. One now exists
 * (web/ios), but this function's one real use is unchanged: deciding
 * whether an sms: URI handoff to the phone's own Messages app makes sense
 * (it does on a phone, it does not on a laptop with no SMS app to hand off
 * to), not anything security or billing sensitive, so user agent sniffing
 * remains good enough here. openExternalLink below, added later, needs a
 * real native-vs-web signal instead: see its own comment for why.
 */
export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

/**
 * Opens a URL outside this app's own UI, never inside this app's own
 * WKWebView, task: "Run a Score Card" button (2026-09-24).
 *
 * @capacitor/browser's Browser.open() already abstracts the platform
 * difference correctly, so this is deliberately a thin wrapper, not a
 * manual Capacitor.isNativePlatform() branch: on web it calls window.open()
 * itself (a real new tab); on iOS it opens an SFSafariViewController, which
 * is Safari's own engine in a native sheet, not this app's WKWebView, the
 * standard, Apple-favored way to open an external link from inside an app.
 * A bare window.open() with no plugin is a well known trap in a Capacitor
 * iOS app: without something handling it, it silently does nothing, or
 * navigates the app's own webview away instead of ever reaching Safari.
 * That risk is exactly why this plugin was added rather than reached for
 * window.open() alone.
 */
export async function openExternalLink(url) {
  const { Browser } = await import('@capacitor/browser')
  await Browser.open({ url })
}
